import { atom } from "recoil";
import { RecoilKeys } from "../../common/miscellaneous/RecoilKeys";

export const outcomeCommentAtom = atom<any>({
  key: RecoilKeys.OutcomeComment,
  default: "",
});
